/* eslint-disable max-len */
var ICON_UI_MENU = {
  v2: true,
  "default": 'M2.25 18.003H21.75M2.25 12.003H21.75M2.25 6.00299H21.75',
  globetrotter: 'M1.875 4.875H22.125M1.875 12H22.125M1.875 19.125H22.125'
};

export { ICON_UI_MENU };
//# sourceMappingURL=ICON_UI_MENU.js.map
